import {format} from "date-fns";
import {utcToZonedTime, zonedTimeToUtc} from "date-fns-tz";

export function utcToLocalMMDDYYYY(utcTimestamp) {
    return format(new Date(utcTimestamp), "P");
}

export function utcToLocalMMDDYYYYWithTime(utcTimestamp) {
    return format(new Date(utcTimestamp), "Pp");
}

export function utcToLocalDateTimeString(utcTimestamp) {
    const timestampAsDate = new Date(utcTimestamp);
    return format(timestampAsDate, "PPPppp");
}

function isDateValid(date) {
    return !Number.isNaN(date.valueOf());
}

/**
 * Converts a dateTime to MM/DD/YYYY
 *
 * Will also check and correct for the following timezones:
 * ChST (Guam), HAST (Hawaii), AKDT (Alaska)
 */
export function givenTimeToLocalTime(timestamp) {
    const timestampAsDate = new Date(timestamp);

    if (isDateValid(timestampAsDate)) return format(timestampAsDate, "P");

    const timeZonePattern = /([A-Za-z]+)$/;

    const timeZoneMatch = timestamp.match(timeZonePattern);

    if (timeZoneMatch && timeZoneMatch.length > 0) {
        const timeZoneAbbreviation = timeZoneMatch[0];

        const targetTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;// Target timezone (client's browser)

        let sourceTimezone;

        if (["hst", "hdt", "hast"].includes(timeZoneAbbreviation.toString().toLowerCase())) {
            sourceTimezone = "Pacific/Honolulu";
        }
        if (["akst", "akdt"].includes(timeZoneAbbreviation.toString().toLowerCase())) {
            sourceTimezone = "America/Anchorage";
        }
        if (timeZoneAbbreviation.toString().toLowerCase() === "chst") {
            sourceTimezone = "Pacific/Guam";
        }

        const utcDate = zonedTimeToUtc(timestamp, sourceTimezone);

        const localDate = utcToZonedTime(utcDate, targetTimezone);

        return format(localDate, "P");

    } else {
        return "invalid date";
    }
}